import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

interface BroadcastEvent {
  key: string;
  data?: any;
}
@Injectable({ providedIn: 'root' })
export class Broadcaster {
  eventBus: Subject<BroadcastEvent>;

  constructor() {
    this.eventBus = new Subject<BroadcastEvent>();
  }

  broadcast(key: string, data?: any): void {
    this.eventBus.next({ key, data });
  }

  on<T>(key: string): Observable<T> {
    return this.eventBus.asObservable()
      .pipe(
        filter((event: BroadcastEvent) => event.key === key),
        map((event: BroadcastEvent) => event.data));
  }
}
